import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { SubsidiaryService } from '../../services/subsidiary.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-display-supplier',
    templateUrl: './display-supplier.component.html',
    styleUrls: ['./display-supplier.component.css', '../../app.component.css']
})

export class DisplaySupplierComponent implements OnInit, OnDestroy {

    supplier: any = [];

    id: string;

    sub: Subscription;
    underSub: Subscription;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private customerSupplierService: CustomerSupplierService,
        private subsidiaryService: SubsidiaryService
    ) {
        this.id = activatedRoute.snapshot.paramMap.get('id');
        this.sub = this.customerSupplierService.getCustomerSupplier(this.id).subscribe(supplierObj => {
            this.supplier = supplierObj;

            this.underSub = this.subsidiaryService.getSubsidiary(supplierObj.subsidiaryId).subscribe(subsidiaryObj => {
                this.supplier.subsidiaryName = subsidiaryObj.name;
                this.underSub.unsubscribe;
            });
        });
    }

    ngOnInit() {

    }
    ngOnDestroy(){
        this.sub.unsubscribe();
    }

}
